import Card from "components/Card/Card";
import CardFooter from "components/Card/CardFooter";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import GridItem from "components/Grid/GridItem";
import InfoIcon from '@material-ui/icons/InfoOutlined';
import Loading from "../Loading/Loading";
import React from "react";
import Update from "@material-ui/icons/Update";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import { loaderStyleEmptyCard } from "../../helpers/CustomStyles";

export class EmptyCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        setTimeout(() => { this.setState({ loading: false }) }, 1000);
    }

    render() {
        const { classes, accountCategory } = this.props;
        if (this.state.loading) {
            return (
                <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                        <div style={loaderStyleEmptyCard}>
                            <Loading transform={0.85} height={90} width={70} color="gray" />
                        </div>
                    </Card>
                </GridItem>
            );
        } else {
            return (
                <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                        <CardHeader color="info" icon>
                            <CardIcon color="info">
                                <InfoIcon />
                            </CardIcon>
                            <br />
                            <h3 className={classes.cardTitle}>You are not connected to a system, yet.</h3>
                            {(accountCategory === "installer" || accountCategory === "wisene")
                                ? <h4 className={classes.cardTitle}>Go to Installer Panel and add a new system.</h4>
                                : null
                            }
                        </CardHeader>
                        <CardFooter stats>
                            <div className={classes.stats}>
                                <Update />
                                Just Updated
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>
            );
        }
    }
}

const emptyCardWithStyles = withStyles(dashboardStyle)(EmptyCard);
export default emptyCardWithStyles;